import React, { Suspense } from 'react'
import Coin from './Coin'
import { Canvas } from '@react-three/fiber'
import { ContactShadows, Environment, OrbitControls } from '@react-three/drei'

function CoinLoader({ scale }) {
  return (
    <div style={{
      width: '50vw',
      height: '500px',
      background: 'transparent',
      top: '25%',
      position: 'absolute',
      zIndex: '2',
      }}>
      <Canvas
        camera={{ position: [0, 0, 5], fov: 30 }}
        gl={{ antialias: true }}
        dpr={[1, 2]}
      >
        <Suspense fallback={null}>
          {/* <ambientLight intensity={10} /> */}

          {/* Top Two Lights */}
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, 20, 60]} rotation={[120, 0, 0]} color="#ffd700" />
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, 20, -60]} rotation={[-120, 0, 0]} color="#ffd700" />

          {/* Bottom Two Lights */}
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, -20, -30]} rotation={[-120, 0, 0]} color="#ffd700" />
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, -20, 30]} rotation={[120, 0, 0]} color="#ffd700" />

          {/* Center Light */}
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, 20, 20]} rotation={[0, -30, 0]} color="#ffd700" />
          <spotLight intensity={1} angle={0.1} penumbra={1} position={[0, 20, -20]} rotation={[0, 30, 0]} color="#ffd700" />

          
          <Coin scale={scale} rotation={[0, Math.PI / 1, 0]} position={[0, -0.8, 0]} />

          <ContactShadows frames={1} position={[0, -0.99, 0]} opacity={1} scale={6} blur={1.5} />
          <Environment preset="forest" rotation={[0, 0, 0]} />
          <OrbitControls 
            minPolarAngle={Math.PI / 2} 
            maxPolarAngle={Math.PI / 2} 
            enableZoom={false} 
            enablePan={false}
            autoRotate
            autoRotateSpeed={4}
          />
        </Suspense>
      </Canvas>
    </div>
  )
}

export default CoinLoader
